import { baseApiService } from "./baseApiService";
import type { ApiResponse, UserDocumentResponse } from "./userDocumentService";

// Workflow history interfaces matching backend DTOs
export interface WorkflowHistoryDto {
  id: string;
  title: string;
  workflowTitle?: string | null;
  status: string;
  timestamp: string; // DateTime as ISO string from backend
  workflow: string;
  workflowType: string;
  companyId: string;
  isMyDocument?: boolean;
  userName?: string;
  jobId?: string;
}

// Workflow specific API calls
export const workflowService = {
  // Get workflow history - companyId is optional (null for non-SuperAdmin users)
  getHistory: (companyId?: string | null, showCompanyHistory?: boolean) => {
    const params = new URLSearchParams();
    if (companyId) {
      params.append('companyId', companyId);
    }
    if (showCompanyHistory !== undefined && showCompanyHistory !== false) {
      params.append('isShowCompanyHistory', showCompanyHistory.toString());
    }
    const queryString = params.toString();
    return baseApiService.get<WorkflowHistoryDto[]>(`/workflow/history${queryString ? `?${queryString}` : ''}`);
  },

  // Get specific history item by ID - returns ApiResponse<UserDocumentResponse>
  // The data object contains different content based on workflow type
  getHistoryById: (id: string) => {
    return baseApiService.get<ApiResponse<UserDocumentResponse>>(`/workflow/history/${id}`);
  },
};
